import { Grid, TableCell, TableRow, Button, Box, useTheme } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../../../common/snippets'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, filterHeaderColumn, filterHeaderColumn1, filterHeaderForOwnBooking, filterHeaderForOwnBooking1 } from '../BookingConstants'
import { OwnBookingDetailedLargePdf } from '../LargePDF'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import AppsIcon from '@mui/icons-material/Apps'
import VirtualizedTable from '../../../../common/virtualisedTable'
import { makeTable } from '../../analysisReport/pdfAutotable'
import { exportToExcel } from '../../../../common/hook'
import { divideInNIntegers } from '../../../../common/mathHelper'
const OwnBookingDetailed = ({
  checkCrossinglr,
  cargoSettingFilterData,
  loginData,
  tableData,
  fromDate,
  toDate,
  sourceCity,
  sourceBranch,
  sourceBranchUser,
  destinationCity,
  destinationBranch,
  paymentType,
  transactionType,
  selReportView,
  status,
  disableExcel,
  headerData,
  updateModal,
  columnSummaryDefs,
}) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const [largePDF, setLargePDF] = useState(false)
  const filterData = {
    fromDate: moment(fromDate).format('DD/MM/YYYY'),
    toDate: moment(toDate).format('DD/MM/YYYY'),
    sourceCityName: sourceCity?.SourceCityName,
    sourceBranchName: sourceBranch?.SourceBranchName,
    SourceBranchUser: sourceBranchUser?.UserBooked,
    destinationCity: destinationCity?.DestCityName,
    destinationBranch: destinationBranch?.DestBranchName,
    paymentType: paymentType?.name,
    transactionType: transactionType?.TransType,
    selReportView: selReportView?.ReportView,
    status: status?.LrStatus
  }
  const headers = columnSummaryDefs.map((item) => {
    return {
      header: item.header,
      field: item.field,
      headerSx: item.headerSx,
      exportHead: item.exportHead,
      textAlign: item.headerSx?.textAlign || 'left',
    }
  })
  const excelHeaders = headers.flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.textAlign },
        { field: field2, header: header2, align: col.textAlign },
      ]
    }
    return { field: col.field, header: col.exportHead, align: col.textAlign }
  })
  const lengths = divideInNIntegers(excelHeaders.length, 3)
  let index = 0
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(excelHeaders[index].field)
    index += span
  })
  const excelData = tableData.map((row) => {
    if (row.dataType === 'subHeader') {
      const colSpan = row.colSpan
      const orderedKeys = headers
        .map((c) => c.field)
        .filter((key) => key in colSpan)
        .map((key) => row[key])
      return {
        ...row,
        ...Object.fromEntries(pickedHeaders.map((key, i) => [key, orderedKeys[i]])),
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
      }
    }
    if (row.dataType === 'total') {
      return {
        ...row,
        colSpan: { [pickedHeaders[0]]: excelHeaders.findIndex((header) => header.field === 'STATUS') },
      }
    }
    return row
  })
  const header1 = [
    [{ header: 'Report For: Booking Report', field: '', span: filterHeaderForOwnBooking.length ,mainHeader:true}],
  ]
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const generatepdf = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    const widthCell = calculateTotalTableWidth(columnSummaryDefs)

    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = filterHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns1 = filterHeaderColumn1.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = columnSummaryDefs.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        sourceCity: sourceCity?.SourceCityName,
        sourceBranch: sourceBranch?.SourceBranchName,
        sourceBranchUser: sourceBranchUser?.UserBooked,
        destCity: destinationCity?.DestCityName,
      },
    ]
    const HeaderData1 = [
      {
        destBranch: destinationBranch?.DestBranchName,
        paymentType: paymentType?.name,
        trnsType: transactionType?.TransType,
        reportView: selReportView?.ReportView,
        status: status?.LrStatus,
      },
    ]
    const doc = new jsPDF({
      orientation: headers.length > 13 ? 'l' : 'p',
      format:
        headers.length > 13
          ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60)
          : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60),
      unit: 'px',
      compress: true,
    })
    var pageSize = doc.internal.pageSize
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var scaleFactor = pageWidth / (headers.length > 13 ? 1122 : 793)
    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(scaleFactor * 14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(
        `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
        doc.internal.pageSize.width / 2 -
          (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
            2 +
          90,
        pageHeight - 5
      )
    }
    doc.setProperties({
      title: `Item List.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
    })

    autoTable(doc, {
      margin: { top: 0, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns1,
      body: HeaderData1,
      columnStyles: {
        0: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: scaleFactor * 14,
          font: 'Roboto',
          valign: 'middle',
          minCellWidth: widthCell / 4,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      showHead: 'everyPage',
      startY: doc.lastAutoTable.finalY,
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report View: Detailed`, 30, 170)
        doc.setFontSize(scaleFactor * 16)
        doc.setFont('Roboto', 'bold')
        doc.text(
          `Inclusive Crossing LRs: ${checkCrossinglr ? 'Yes' : 'No'}`,
          doc.internal.pageSize.width - data.settings.margin.left,
          170,
          'right'
        )
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Booking Date : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, 30, 145)
        doc.setFontSize(scaleFactor * 16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report: Own Bookings`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
        doc.setTextColor(scaleFactor * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(scaleFactor * 20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Own Booking Reports', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 20).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    makeTable(doc, autoTable, pdfColumns, tableData, 1, 'own booking', loginData, 'everyPage', () => {}, 120, false)
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Own ${'Booking'} Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('ownBooingDetailed').data = pdfUrl
        // document.getElementById('ownBooingDetailed').data = doc.output('datauristring', 'Booking Report')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('ownBooingDetailed').data = pdfUrl
        // document.getElementById('ownBooingDetailed').data = doc.output('datauristring', 'Item List.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const printClick = (isSave) => {
    setShowTable(false)
    generatepdf(isSave)
  }
  const headerContent = () => {
    return (
      <>
        <TableRow>
          <TableCell
            className="reportTD"
            style={{
              fontWeight: 'bold',
              fontSize: '12px',
              lineheight: '16px',
              letterspacing: '0.24px',
              fontWeight: '500',
              textAlign: 'left',
              color: '#444444',
              backgroundColor: '#bfe1ff',
              position: 'sticky',
              top: '0px',
              height: '36px',
              padding: '10px 4px',
            }}
            colSpan={headers.length}
          >
            Booking Report
          </TableCell>
        </TableRow>
        <TableRow style={{ height: '47px' }}>
          {headers.map((item) => {
            return (
              <TableCell
                style={{
                  ...item?.headerSx,
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  padding: '10px 4px',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        color: '#444',
        padding: '10px 4px',
        whiteSpace: 'pre',
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '600',
          textAlign: align || 'left',
          height: '36px',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
        }
      }
    }

    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            const colSpan = row.colSpan?.[item.field] || 1
            skip = colSpan - 1
            return (
              <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.textAlign)}>
                {row[item.field]}
              </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={headers} />
  }
  return (
    <>
      <Grid container className="itemButtons" style={{ paddingTop: '5px' }}>
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h2 style={{ paddingLeft: '15px' }}>Report For: Own Bookings</h2>
          <Box
            style={{ height: '32px', display: 'flex', padding: '8px 12px', justifycontent: 'center', alignitems: 'center', gap: '6px' }}
            id="dispatchReportManageColumn"
            tabIndex={0}
            onClick={() => updateModal(true, 'ownBookingShowManageColumn')}
          >
            <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
              <AppsIcon />
            </span>
            <span tabIndex={0} style={{ fontWeight: 'bold' }}>
              MANAGE COLUMNS
            </span>
          </Box>
        </Box>
        {showTable ? (
          <>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', width: '50%', paddingRight: '12px', alignItems: 'center' }}>
              <Box>
                <Item>
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    className="receiveitembtn"
                    disabled={disableExcel}
                    onClick={(e) => {
                      e.preventDefault()
                      exportToExcel({
                        fileName: `Own Booking Report ${currentDateTime}.xlsx`,
                        sheetName: 'OwnBooking',
                        headersList: [header1,filterHeaderForOwnBooking,filterHeaderForOwnBooking1,excelHeaders],
                        dataList: [[],[filterData],[filterData],excelData],
                      })
                    }}
                  >
                    Export to Excel
                  </Button>
                </Item>
              </Box>
              <Box>
                <Item>
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    className="receiveitembtn"
                    onClick={() => {
                      setShowTable(false)
                      if (tableData?.length > 5000) {
                        setLargePDF(true)
                      } else {
                        printClick(true)
                      }
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'PrintBtn', disableExcel ? 'OwnSplitBtn' : 'ExpToExlbtn', () => {
                        generatepdf(true)
                      })
                    }
                    id="exportAsPdfBtn"
                  >
                    Export to Pdf
                  </Button>
                </Item>
              </Box>
              <Box>
                <Item>
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    className="receiveitembtn"
                    onClick={() => {
                      setShowTable(false)
                      if (tableData?.length > 5000) {
                        setLargePDF(true)
                      } else {
                        printClick(false)
                      }
                    }}
                    id="PrintBtn"
                    onKeyDown={(e) =>
                      navigation3(e, 'fromDate', 'exportAsPdfBtn', () => {
                        generatepdf(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Item>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Item style={{ textAlign: 'right', width: '50%', paddingRight: '22px' }}>
              <Button
                id="backBtn"
                variant="outlined"
                style={{
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  fontSize: '15px',
                  color: '#fe5200',
                  background: 'white',
                  marginLeft: '620px',
                  border: '2px solid #fe5200',
                }}
                onClick={() => {
                  setShowTable(true)
                  setLargePDF(false)
                }}
                onKeyDown={(e) =>
                  navigation3(e, 'fromDate', 'OwnSplitBtn', () => {
                    setShowTable(true)
                    focusElemnt('OwnSplitBtn')
                  })
                }
              >
                Back
              </Button>
            </Item>
          </>
        )}
      </Grid>
      {showTable ? (
        <VirtualizedTable
          tableData={tableData}
          headerContent={headerContent}
          rowContent={bodyContent}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          autoResize={true}
        />
      ) : (
        <>
          {largePDF ? (
            <OwnBookingDetailedLargePdf
              headerData={headerData}
              tableData={tableData}
              cargoSettingFilterData={cargoSettingFilterData}
              fromDate={fromDate}
              toDate={toDate}
              selReportView={selReportView}
            />
          ) : (
            <>
              {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
              {load ? (
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                  <object
                    id="ownBooingDetailed"
                    type="application/pdf"
                    width="100%"
                    height="440"
                    title="MTLPL -Cargo System - After Transfer Summary Report"
                    aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                  ></object>
                </Box>
              ) : (
                ''
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
export default OwnBookingDetailed
